const types = {
    UPLOAD_TOKEN_SET_UPLOAD_TOKEN: 'UPLOAD_TOKEN_SET_UPLOAD_TOKEN',
    UPLOAD_TOKEN_REMOVE_UPLOAD_TOKEN: 'UPLOAD_TOKEN_REMOVE_UPLOAD_TOKEN',
};

const uploadTokenActions = {
    types,

    setUploadToken(questionId, uploadToken) {
        return {
            type: types.UPLOAD_TOKEN_SET_UPLOAD_TOKEN,
            questionId,
            uploadToken,
        };
    },

    removeUploadToken(questionId) {
        return {
            type: types.UPLOAD_TOKEN_REMOVE_UPLOAD_TOKEN,
            questionId,
        };
    },
};

export default uploadTokenActions;
